import { request } from "../../utils/AxiosInstance";
export const useStateDropdownApi = async (data) => {
  const params = data.queryKey[1];
  return request({
    url: `/states/${params}`,
  });
};
